<div class="d-flex flex-wrap align-items-center check-filter-benchmark--items">
  <c11n-checkbox labelText="{{fd3tableContentList.benchmark}}" class="c11n-checkbox__input checkbox__label-content" *ngIf=" viewType !== literature && viewType === performance || viewType === monthEndReturnsMarketETF ">
    <input c11nCheckboxInput id="benchMark" data-rpa-tag-id="benchmark-checkbox" type="checkbox" [checked]="isBenchmark" (click)="benchmarkClicked()"/>
  </c11n-checkbox>
  <div  *ngIf="isAllShareClassApplied">
    <c11n-checkbox labelText="{{fd3tableContentList.allShareClass}}" class="c11n-checkbox__input checkbox__label-content input-left-margin">
      <input c11nCheckboxInput id="allShareClasses" data-rpa-tag-id="all-share-class-checkbox" type="checkbox" [checked]="isSharedClass" (click)="sharedClassClicked()"/>
    </c11n-checkbox>
  </div>
  <div class="d-flex nav-switch-Container nav-switch-circle switch-nav-align" *ngIf="viewType !== literature && (viewType === performance || viewType === monthEndReturnsMarketETF)">
    <span class="">{{fd3tableContentList.nav}}</span>
    <sr-only class="sr-only" id="switchlabel" [innerHTML]="navSwitchValue ? 'Switch ' + fd3tableContentList.market + ', Switch is currently' : 'Switch ' + fd3tableContentList.nav + ', Switch is currently'"></sr-only>
    <button data-rpa-tag-id="nav-mkt-toggle" class="mx-2" c11n-switch id="switch1"  hideLabel="true" hideIcon="true"
            labelPosition="leading"
            aria-labelledby="switchlabel"
            (stateChange)="navSwitchAccessibility($event)"
            [disabled]="!isNavMarketPriceApplicable"
            [class.inactive]="!isNavMarketPriceApplicable"
            (click)="toggleNavMarketPrice()" [isChecked]="selectedFilter.toggleOn && viewType === MONTH_END_RETURN_MARKET_ETF"
    ></button>
    <span class="">{{fd3tableContentList.market}}</span>
  </div>
</div>
